// extracted by mini-css-extract-plugin
module.exports = {"loaderWrap":"LoadingSpinner_loaderWrap__29QQ_","lds-facebook":"LoadingSpinner_lds-facebook__2VDpH"};